import {
  List,
  DatagridConfigurable,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  useDefaultTitle,
  useListContext,
  FunctionField,
  ExportButton,
  DateInput,
  FilterButton,
  RichTextField,
} from "react-admin";
import LikeShow from "./HandsUpShow";
import { Timestamp } from "firebase/firestore";
import { Typography, Chip } from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";

const listFilters = [
  <DateInput source="time_gte" alwaysOn />,
  <DateInput source="time_lte" alwaysOn />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <ExportButton />
  </TopToolbar>
);

// Custom time formatting field
const FormattedTimeField = ({ record }: { record?: any }) => {
  if (!record?.time) return null;
  const date =
    record.time instanceof Timestamp
      ? record.time.toDate()
      : new Date(record.time);
  return <span>{date.toLocaleString()}</span>;
};

// Updated title component (you can change the naming as needed)
const UserActionsTitle = () => {
  const title = useDefaultTitle();
  const { defaultTitle } = useListContext();
  return (
    <>
      <title>{`${title} - ${defaultTitle}`}</title>
      <span>{defaultTitle}</span>
    </>
  );
};

const HandsUpList = () => (
  <List
    resource="userActions"
    queryOptions={{ meta: { type_eq: "handsUp" } }}
    perPage={25}
    sort={{ field: "time", order: "DESC" }}
    actions={<ListActions />}
    filters={listFilters}
    title={<UserActionsTitle />}
  >
    <DatagridConfigurable
      rowClick="expand"
      bulkActionButtons={false}
      expand={<LikeShow />}
      sx={{
        // Optional: Hide some columns on smaller devices if desired
        "& .column-referenceId": {
          display: { xs: "none", md: "table-cell" },
        },
        "& .column-referenceType": {
          display: { xs: "none", md: "table-cell" },
        },
        "& .column-userId": {
          display: { xs: "none", md: "table-cell" },
        },
        "& .column-count": {
          display: { xs: "none", md: "table-cell" },
        },
      }}
    >
      <TextField source="userName" sortable={false} />
      <TextField source="social" sortable={false} />
      <TextField source="email" sortable={false} />
      <FunctionField
        label="Time"
        render={(record) => <FormattedTimeField record={record} />}
      />
      <TextField source="referenceType" sortable={false} />
      <FunctionField
        source="message"
        label="Message"
        render={(record) => <TextField source="message" record={record} />}
      />
      <FunctionField
        label="Audio"
        render={(record) =>
          record?.sound ? (
            <Chip
              icon={<MicIcon />}
              label={`${Math.floor(record.sound.duration)}s`}
              size="small"
              color="primary"
              variant="outlined"
            />
          ) : null
        }
      />
    </DatagridConfigurable>
  </List>
);

export default HandsUpList;
